import React, { useState } from 'react';
import { Col, Text, useDynamicResponsiveValue } from 'react-quick-style-components';
import { Input, Button, Header, Popup, showModal, hideModal } from 'components'
import { ASSETS, COLOR, fSize, SCREEN_NAME, spacing } from 'const';
import { StyleSheet, Image } from 'react-native';
import { IScreen } from 'type';
import { useNavFunc } from 'navigation';
import GlobalEvent from 'js-events-listener/react';
import Store from 'store';
import { MaterialIcons } from '@expo/vector-icons';

const ForgottenPassword: IScreen = () => {
  const { reset, navigate } = useNavFunc();
  const rV = useDynamicResponsiveValue();
  

  const [{ name : savedName, email: savedEmail }, uApi] = Store.User.createStore();

  const [, cApi] = Store.Client.createStore();

  const [name, setName] = useState(savedName);
  const [email, setEmail] = useState(savedEmail);
  const [loading, setLoading] = useState(false);
  // 'NOT_APPROVED': email is not on the approved client list
  // 'NOT_REGISTERED': email is approved but has no account yet
  const [emailIssue, setEmailIssue] = useState<'' | 'NOT_APPROVED' | 'NOT_REGISTERED'>('');

  const handleLogin = async () => {
    // GlobalEvent.emit('LOGIN', undefined);
    // reset(SCREEN_NAME.Home);

    const trimmedEmail = (email || '').trim();
    if (!trimmedEmail) return Popup.showError('Please input your email');
    if (loading) return;
    setEmailIssue('');
    setLoading(true);
    try {
      const [status, errCheck] = await cApi.checkEmailStatus(trimmedEmail);
      // if the check fails, fall back to the normal reset flow
      if (!errCheck && status) {
        if (!status.verified) return setEmailIssue('NOT_APPROVED');
        if (status.registered === false) return setEmailIssue('NOT_REGISTERED');
      }

      const [res, err] = await uApi.sendPasswordResetEmail(trimmedEmail);
      if (err) {
        if (err?.code === 'auth/user-not-found') return setEmailIssue('NOT_REGISTERED');
        return Popup.showError(err?.message || String(err));
      }
    } finally {
      setLoading(false);
    }
    
    // Show success message with custom styling
    showModal({
      component: (
        <Col style={styles.successModal}>
          <MaterialIcons name="check-circle" size={48} color="#4CAF50" style={{ alignSelf: 'center', marginBottom: 16 }} />
          <Text style={styles.successTitle}>Email Sent Successfully!</Text>
          <Text style={styles.successMessage}>Request sent, please check your mail box</Text>
          <Text style={styles.successMessage}>Note: Please check your <Text style={styles.successMessageSpam}>spam</Text> folder if you don't see the email in your inbox.</Text>
          <Button
            title="OK"
            onPress={() => hideModal()}
            style={styles.successButton}
          />
        </Col>
      )
    });
  };

  return (
    <Col flex1>
      <Header />
      <Col flex1 backgroundColor={COLOR.BG} middle>
        <Col width={rV({ xs: '90%', sm: '80%', md: '70%', lg: '60%', xl: '50%' })} >
          <Col style={[styles.contentBox, { paddingBottom: rV({ xs: 40, xxxl: 65 }) }]} >
            <Col alignItems="center">
              <Image source={ASSETS.LOGIN_LOGO_DARK} style={{ width: 306 * 0.8 , height: 156 * 0.8, resizeMode: 'contain' }} />
            </Col>
            <Text textAlign="center" bold fontSize={fSize(rV, 50)} colorMain paddingVertical16>LOGIN</Text>
            <Col marginHorizontal={rV({ xs: spacing[4], md: spacing[8], lg: spacing[12], xl: spacing[16] })}>
              {/* <Input label="Your name"
                value={name} onChangeText={setName}
              /> */}
              <Input label="Email Address"
                value={email} onChangeText={(text) => { setEmail(text); setEmailIssue(''); }}
              />
              {emailIssue === 'NOT_REGISTERED' && (
                <Col style={styles.issueBox}>
                  <Text style={styles.issueTitle}>This email has not been registered yet</Text>
                  <Text style={styles.issueMessage}>
                    Your email is on our approved client list, but you haven't created an account yet, so there is no password to reset. Please register first to access the portal.
                  </Text>
                  <Text
                    style={styles.issueLink}
                    onPress={() => navigate(SCREEN_NAME.Register)}
                  >
                    Register now
                  </Text>
                </Col>
              )}
              {emailIssue === 'NOT_APPROVED' && (
                <Col style={styles.issueBox}>
                  <Text style={styles.issueTitle}>This email is not on our approved client list</Text>
                  <Text style={styles.issueMessage}>
                    Only approved clients can access the portal. Please check the email address for typos, or try another email address you have used with Vintage Acquisitions.
                  </Text>
                </Col>
              )}
            </Col>
            <Button
              marginTop={rV({ xs: 30, xxxl: 59 })}
              width={250}
              title={loading ? "PLEASE WAIT..." : "SEND RESET MAIL"} alignSelf="center" onPress={handleLogin} />
          </Col>
          <Text
            fontSize={fSize(rV, 24)} colorMain paddingTop13 textAlign="center"
            textDecorationLine='underline'
            onPress={() => navigate(SCREEN_NAME.Register)}
          >
            Don’t have an account? Register now
          </Text>
        </Col>
      </Col>
    </Col>
  );
};

ForgottenPassword.routeInfo = {
  title: 'Forgotten Password',
  path: '/forgotten-password',
}

const styles = StyleSheet.create({
  contentBox: {
    paddingTop: 32,
    backgroundColor: COLOR.WHITE,
    borderColor: COLOR.BORDER,
    borderWidth: 1,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  issueBox: {
    marginTop: 16,
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#F0C36D',
    backgroundColor: '#FFF8E6',
  },
  issueTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#8A5A00',
    marginBottom: 6,
  },
  issueMessage: {
    fontSize: 14,
    color: '#5C4A1E',
    lineHeight: 20,
  },
  issueLink: {
    marginTop: 10,
    fontSize: 15,
    fontWeight: 'bold',
    color: COLOR.MAIN,
    textDecorationLine: 'underline',
  },
  successModal: {
    paddingVertical: 24,
    paddingHorizontal: 32,
    backgroundColor: 'white',
    borderRadius: 12,
    width: 320,
    alignSelf: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
  },
  successTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#2E7D32',
    marginBottom: 8,
  },
  successMessage: {
    fontSize: 16,
    textAlign: 'center',
    color: '#666',
    marginBottom: 24,
    lineHeight: 22,
  },
  successMessageSpam: {
    fontWeight: 'bold',
  },
  successButton: {
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
})
export default ForgottenPassword;

